import Vue from 'vue'

import Vuex from 'vuex'
import VueResource from 'vue-resource'
import App from './App.vue'

Vue.use(Vuex)
Vue.use(VueResource)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    tableIsLoaded: false,
    downloadingURL: '',
    dataset: ''
  },
  mutations: {
  	setTableLoadStatus: (state, value) => state.tableIsLoaded = value,
    loadTableData: (state, dataset) => Vue.set(state.dataset, 0, dataset),
    //loadTableData: (state, dataset) => state.dataset = Object.assign({}, dataset),
    loadTableData: (state, dataset) => state.dataset = Object.assign({}, dataset, {1: dataset}),
    //setDownloadingURL: (state, url) => state.downloadingURL = url,
  	increment: state => state.count++,
    decrement: state => state.count--
  }
})

new Vue({
  render: h => h(App),
  store: store
}).$mount('#app')
